import {Component, OnInit, SecurityContext, ViewChild} from '@angular/core';
import {TagsComponent} from '../../tags/tags.component';
import {MessageTypes} from '../../message';
import {ApiService} from '../../api.service';
import {MessageService} from '../../message.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-edit-file',
    templateUrl: './edit-file.component.html',
    styleUrls: ['./edit-file.component.css']
})
export class EditFileComponent implements OnInit {
    @ViewChild(TagsComponent)
    protected tagsComponent: TagsComponent;
    title = 'New File';
    file: any;
    filename = '';
    state = '';
    submitLabel = 'save';
    id = '';
    uploadfile: any;

    constructor(protected apiService: ApiService,
                protected messageService: MessageService,
                protected router: Router,
                private route: ActivatedRoute) {
        this.file = {id: 0, title: '', tags: []};
    }

    ngOnInit() {
        const id = this.route.snapshot.paramMap.get('id');
        this.state = '';
        if (id) {
            this.title = 'Edit File';
            this.id = id;
            this.state = 'loading';
            this.submitLabel = 'update';
            this.loadFile();
        } else {
            this.submitLabel = 'save';
        }
        // console.log('getting file with id', this.id);
    }

    loadFile() {
        this.submitLabel = 'loading';
        this.apiService.getById('files', this.id).subscribe(
            (value) => {
                this.file = value;
                this.tagsComponent.tags = this.file.tags;
                this.state = '';
                this.submitLabel = 'update';
            }, (error) => {
                this.state = '';
                this.submitLabel = 'update';
            }
        );
    }

    showFilename(event) {
        this.file.filename = event.target.files[0].name;
        this.file.uploadfile = event.target.files[0];
    }

    submit() {
        this.state = 'saving';
        this.submitLabel = 'saving';
        this.file.tags = this.tagsComponent.tags;
        // console.log('calling submit with: ', this.file);
        const uploadData = new FormData();

        if (this.file.uploadfile) {
            uploadData.append('uploadfile', this.file.uploadfile, this.file.filename);
        }
        uploadData.append('title', this.file.title);
        uploadData.append('tags', this.file.tags.join(','));
        // todo: validate form - url must be filled
        if (this.id) {
            this.apiService.put('files', this.id, uploadData)
                .subscribe(
                    (value: any) => {
                        this.state = '';
                        this.messageService.setMessage('File got updated', MessageTypes.Success);
                        this.submitLabel = 'update';
                    },
                    (err) => {
                        this.state = '';
                        this.messageService.setMessage('An error occurred - the file didn`t get updated', MessageTypes.Error);
                        this.submitLabel = 'update';
                    });
        } else {
            this.apiService.post('files', uploadData)
                .subscribe(
                    (value: any) => {
                        this.state = '';
                        this.messageService.setMessage('File got saved', MessageTypes.Success);
                        this.router.navigate(['/files/list']);
                    },
                    (err) => {
                        this.state = '';
                        this.messageService.setMessage('An error occurred - the file didn`t get saved', MessageTypes.Error);
                        this.submitLabel = 'save';
                    });
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/files/edit-file/edit-file.component.ts